module.exports = __webpack_public_path__ + "img/alain_souchon-ame_fifties.12f637c1.jpg";